var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-button-wrapper"},[_c('button',{staticClass:"google-button social-button",on:{"click":_vm.submit}},[_c('img',{attrs:{"src":require("@/assets/images/SignIn/google.svg"),"alt":"Google"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }